/* unplugin-vue-components disabled */import script from "./lectureEndCard.vue?vue&type=script&setup=true&lang=js"
export * from "./lectureEndCard.vue?vue&type=script&setup=true&lang=js"

import "./lectureEndCard.vue?vue&type=style&index=0&id=6044e44b&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6044e44b"]])

export default __exports__